import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import TestSide from "./TestSide";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const isNonMobileScreen = useMediaQuery("(min-width:767px)");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isNonMobileScreen) {
      setOpen(false);
    } else setOpen(true);
  }, [isNonMobileScreen]);

  const onOpenSidebar = (isClickAway) => {
    console.log(isClickAway, 'isClickAway', open)
    setOpen(prev => !prev)
  };
  
  return (
    <RootStyle>
      <DashboardNavbar
        onOpenSidebar={()=>onOpenSidebar()}
        handleSidebar={() => setOpen(true)}
        isNonMobileScreen={isNonMobileScreen}
      />
      <TestSide
        open={open}
        handleSidebar={() => setOpen(true)}
        isNonMobileScreen={isNonMobileScreen}
        handleClick={()=>onOpenSidebar(true)}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
